import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * AdSense policy: ads must only appear on content pages with substantive
 * editorial value. This component adds/removes a `noads` class on <html>
 * whenever the user is on a page where ads must not be shown (admin, login,
 * 404, thank-you pages, etc.). The AdSlot component and any Auto-ad
 * placements can then be suppressed via CSS.
 */
const NO_ADS_ROUTES = ["/admin", "/admin/login", "/404"];

export default function AdPolicyGuard() {
  const { pathname } = useLocation();

  useEffect(() => {
    const suppress = NO_ADS_ROUTES.some(
      (p) => pathname === p || pathname.startsWith(p + "/"),
    );

    const html = document.documentElement;
    if (suppress) {
      html.setAttribute("data-noads", "true");
    } else {
      html.removeAttribute("data-noads");
    }
  }, [pathname]);

  return null;
}
